import { createAction, createSlice } from "@reduxjs/toolkit";
import { createSelector } from "reselect";
import _ from "lodash";
import { apiCallBegan } from "./api";
import {
  arrayToObjectForMyQuotes,
  convertArrayOfObjectsToId,
} from "./helperfuncs";

const slice = createSlice({
  name: "myreminder",
  initialState: {
    clientListArray: [],
    groupArray: [],
    createreminderResp: {},
    clientDetailsForReminderData: [],
    category: [],
    getReminder: [],
    updatereminderStatus: {},
    getReminderData: [],
    reminderSingleObject: {},
    gettingMyReminders: false,
    gettingMyRemindersFailed: false,
    gettingMyRemindersSuccess: false,
    reminderView: {},
  },
  reducers: {
    categoryReminderSuccess: (myreminder, action) => {
      myreminder.category = action.payload.reminderCategories;
    },
    gettingReminderSingleObject: (myreminder, action) => {
      myreminder.reminderSingleObject = action.payload;
    },
    reminderSingleObjectClear: (myreminder, action) => {
      myreminder.reminderSingleObject = {};
    },
    gettingMyRemindersInitialized: (myreminder, action) => {
      myreminder.isLoading = true;
      myreminder.gettingMyReminders = true;
      myreminder.gettingMyRemindersFailed = false;
      myreminder.gettingMyRemindersSuccess = false;
    },

    gettingMyReminderFailed: (myreminder, action) => {
      myreminder.gettingMyReminders = false;
      myreminder.gettingMyRemindersFailed = true;
      myreminder.gettingMyRemindersSuccess = false;
    },

    gettingMyRemindersSuccess: (myreminder, action) => {
      myreminder.gettingMyReminders = false;
      myreminder.gettingMyRemindersFailed = false;
      myreminder.gettingMyRemindersSuccess = true;
      myreminder.getReminder = action.payload.reminderList;
      myreminder.getReminderData = arrayToObjectForMyQuotes(
        action.payload.reminderList,
        "_id"
      );
    },
    gettingGroupData: (myreminder, action) => {
      myreminder.groupArray = action.payload;
    },
    gettingReminderCreated: (myreminder, action) => {
      myreminder.createreminderResp = action.payload ? action.payload : {};
    },
    clientListSuccess: (myreminder, action) => {
      myreminder.clientListArray = action.payload;
    },
    reminderViewSuccess: (myreminder, action) => {
      myreminder.reminderView = action.payload;
    },
    gettingReminderStatusUpdate: (myreminder, action) => {
      myreminder.updatereminderStatus = action.payload;
    },
  },
});

export const {
  gettingGroupData,
  categoryReminderSuccess,
  reminderSingleObjectClear,
  gettingReminderSingleObject,
  gettingMyRemindersInitialized,
  gettingMyRemindersSuccess,
  gettingMyReminderFailed,
  gettingReminderCreated,
  gettingReminderStatusUpdate,
  clientListSuccess,
  reminderViewSuccess,
} = slice.actions;

export default slice.reducer;

// Action Creators
export const getGroupList = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder-group",
    method: "get",
    data: data,
    onSuccess: gettingGroupData.type,
  });
export const getReminderCategoryList = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder-category",
    method: "get",
    data: data,
    onSuccess: categoryReminderSuccess.type,
  });
export const getClientList = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/policies/get-my-clients",
    method: "get",
    data: data,
    onSuccess: clientListSuccess.type,
  });
export const getReminderView = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder/viewed",
    method: "put",
    data: data,
    onSuccess: reminderViewSuccess.type,
  });
export const getMyReminders = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder",
    method: "get",
    params: data,
    onStart: gettingMyRemindersInitialized.type,
    onSuccess: gettingMyRemindersSuccess.type,
    onError: gettingMyReminderFailed.type,
  });

export const createRemider = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder",
    method: data.reminder._id ? "put" : "post",
    data: data,
    onSuccess: gettingReminderCreated.type,
  });

export const updateReminderStatus = (data) =>
  apiCallBegan({
    serviceUrl: process.env.REACT_APP_BASICSERVICE,
    url: "/api/reminder/status",
    method: "put",
    data: data,
    onSuccess: gettingReminderStatusUpdate.type,
  });

//selectors

export const getClientDetailsForReminders = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.clientDetailsForReminderData
);
export const getCategoryList = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.category
);
export const getReminders = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.gettingMyReminders
);
export const getRemindersSuccessValue = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.gettingMyRemindersSuccess
);
export const getRemindersFailedValue = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.gettingMyRemindersFailed
);
export const getArrayOfProspectsId = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.order
);
export const getreminderArrayResp = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.getReminder
);
export const getReminder = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder
);
export const getReminderSingleObject = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.reminderSingleObject
);
export const getCreatedReminderResponse = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.createreminderResp
);
export const getGroupSelectArray = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.groupArray.data
);
export const getClientListData = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.clientListArray.clientList
);
export const getreminderStatusUpdate = createSelector(
  (state) => state.entities.myreminder,
  (myreminder) => myreminder.updatereminderStatus
);
